import { motion } from "framer-motion";
import styled, { css } from "styled-components";

export const Div = styled.div`
   ${({ fullWidth }) => fullWidth && "width: 100%;"}
   position: relative;
   display: inline-block;
   width: 100%;
`;

export const Label = styled.label`
    pointer-events: none;
    color: ${({ theme }) => theme.colors?.grey};
    white-space: nowrap;
    font-weight: 500;
    font-size: 1.4rem;
    text-transform: capitalize;
    
`;

export const AdornmentWrapperDiv = styled.div`
   display: flex;
   align-items: center;
   white-space: nowrap;
   position: absolute;

   &.start {
      left:1.4rem;
      svg {
         width: 15px;
         height: 15px;
      }
   }
   &.end {
    right: 1.764rem;
    top: 2.2rem;
    bottom: 1.95rem;
   }
`;

export const InputWrapperDiv = styled.div`
   position: relative;
   display: flex;
   align-items: center;
   width: 100%;
   ${({ fullHeight }) => fullHeight && "height: 100%;"}
`;

function variantInputStyles({ variant }) {
   switch (variant) {
      case "secondary":
         return css`
            background-color: ${({ theme }) => theme && theme.colors?.white600};
            color: ${({ theme }) => theme && theme.colors?.white};
            border:  ${({ theme, error }) => error ? `1px solid ${theme.colors?.redError}` : 'none'};
         
            &::placeholder {
                 font-size: 1.4rem;
                 color: ${({ theme }) => theme && theme.colors?.white50};
            }
          `;
      default:
      case "primary":
         return css`
            border: 1px solid #BDBDBD;
            background-color: #fbfbfb;
         
            &::placeholder {
                 font-size: 1.6rem;
                 color: ${({ theme }) => theme && theme.colors?.japaaBlack};
            }
          `;
   }
}

export const InputField = styled.input`
   width: 100%;
   outline: none;
   font-size: 1.5rem;
   margin-top: 1rem;
   appearance: none;
   padding: 0 ${({ startAdornment, endAdornment }) => (endAdornment ? "6.2rem 0 1.6rem" : startAdornment ? "2.4rem 0 4.2rem" : "1.764rem 0 1.6rem")};
   box-sizing: border-box;
   height: 5rem;
   border-radius: 5px;
   border: 2px solid rgba(84, 95, 125, 0.15);
   background-color: ${({ theme }) => theme && theme.colors?.white};
   ${({ fullHeight }) =>
      fullHeight &&
      css`
         height: 100%;
      `}
   

   &::-ms-clear {
      display: none;
   }

   &::-ms-expand {
      display: none;
   }

   &:-moz-ui-invalid {
      box-shadow: none;
   }

   &[type=number] {
      text-align: center;
      &::placeholder {
         text-align:center;
    }
    }


   &::placeholder {
        font-family: Work Sans;
        font-size: 1.4rem;
        color: ${({ theme }) => theme && theme.colors?.grey};
        opacity: 0.6;
   }

   &:-webkit-autofill,
   &:-webkit-autofill:hover,
   &:-webkit-autofill:focus,
   &:-webkit-autofill:active {
      transition: background-color 5000s;
   }

   &:disabled {
      /* background-color: hsl(0, 0%, 95%); */
      font-family: Inter;
        font-size: 1.4rem;
        color: ${({ theme }) => theme && theme.colors?.white};
   }

   /* ${variantInputStyles} */
`;

export const ErrorText = styled(motion.p)`
   font-family: Work Sans;
   margin: 8px 0 0 0;
   color: ${({ theme }) => theme.colors?.redError};
   font-size: 1.4rem;
   font-weight: 400;

   ${({ easyFlow }) =>
      easyFlow &&
      css`
         margin: 0;
         position: absolute;
         left: 65px;
         bottom: -21px;
         font-size: 11.5px;
      `}
`;

export const PasswordControlButton = styled.span`
    /* background: none;
    border: none; */
    /* width: 5rem; */
    /* overflow: hidden; */
    cursor: pointer;
    font-weight: 600;
    font-size: 1.2rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;

    color: ${({ theme }) => theme && theme.colors?.green};
`;

export const InputWrapper = styled.div`
    margin-top: 2.4rem;
    width: 100%;

    &.grid-2-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        column-gap: 20px;

        @media only screen and (max-width: 468px) {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            row-gap: 20px;
            width: 100%;
        }
    }
`;
